import React, { useState } from 'react';
import { FilterSideDrawer } from 'cards/components/CardListing/CardListingRedesign/CardListingFilter/FilterMobileMenuV2/FilterSideDrawer';
import { FilterKey, FilterValue, CardListingSearchFilters } from '../CardListingFilter/FilterTypes';
import { FreeSamples } from './FreeSamples';
import { StickyBar } from './StickyBar';

interface CardListingMobileHeaderProps {
  activeCardEvent: string;
  filterMenuList: any[];
  clearFilters: () => void;
  updateFilter: (filterKey: FilterKey, filterValue?: FilterValue) => void;
  searchTotal: number;
  searchFilters: CardListingSearchFilters;
}

export const CardListingMobileHeader: React.FC<CardListingMobileHeaderProps> = ({
  filterMenuList,
  clearFilters,
  updateFilter,
  searchTotal,
  searchFilters,
}) => {
  const [activeFilter, setActivedFilter] = useState<string | null>(null);
  const openDrawer = (newFilter: string) => setActivedFilter(newFilter);
  const closeDrawer = () => setActivedFilter(null);

  return (
    <>
      <FreeSamples />
      <StickyBar
        filterMenuList={filterMenuList}
        clearFilters={clearFilters}
        updateFilter={updateFilter}
        openDrawer={openDrawer}
        searchTotal={searchTotal}
        searchFilters={searchFilters}
      />
      <FilterSideDrawer
        activeFilter={activeFilter}
        filterMenuList={filterMenuList}
        onClose={closeDrawer}
        clearFilters={clearFilters}
        updateFilter={updateFilter}
        searchTotal={searchTotal}
        searchFilters={searchFilters}
      />
    </>
  );
};
